import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { getDocuments } from "api/documents";
import theme from "assets/theme";
import BaseTable from "components/DataTable/BaseTable";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { formatDateTime, formatFileSize, STATUS_ACTIVE } from "utils/helper";

const TABLE_COLUMNS = [
    { id: "name", Header: "Name", accessor: "name", align: "left" },
    { id: "file_size", Header: "File Size", accessor: "fileSize", align: "left" },
    { id: "file_type", Header: "File Type", accessor: "fileType", align: "left" },
    { id: "category", Header: "Category", accessor: "category", align: "left" },
    { id: "category_tag", Header: "Category tag", accessor: "category_tag", align: "left" },
    { id: "created_at", Header: "Created At", accessor: "created_at", align: "left" },
    { id: "status", Header: "Status", accessor: "status", align: "left" },
];

export const parentRoute = '/documents';

function DocumentsTable() {
    const navigate = useNavigate();
    const location = useLocation();
    const [refreshKey] = useState(0);
    const savedState = location.state || { sort: "created_at", dir: "desc" };

    const createTableRow = useCallback((item) => ({
        name: <MDTypography
            component="div"
            variant="standard"
            sx={{
                cursor: "pointer",
                '&:hover': {
                    color: theme.palette.primary.main,
                }
            }}
            onClick={() => window.open(item.file_name, '_blank')}
        >
            {item.name}
        </MDTypography>,
        fileSize: <MDTypography component="div" variant="standard" color="text">{formatFileSize(item.file_size)}</MDTypography>,
        fileType: <MDTypography component="div" variant="standard" color="text">{item.file_type}</MDTypography>,
        category: <MDTypography component="div" variant="standard" color="text">{item.category?.name}</MDTypography>,
        category_tag: <MDTypography component="div" variant="standard" color="text">{item.category_tag?.name}</MDTypography>,
        created_at: <MDTypography component="div" variant="standard" color="text">
            {formatDateTime(item.created_at)}
        </MDTypography>,
        status: <MDTypography component="div" variant="standard" color={item.status?.id === STATUS_ACTIVE ? "success" : "error"}>
            {item.status?.name}
        </MDTypography>
    }), []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <BaseTable
                key={refreshKey}
                queryKey={["documents"]}
                title="Documents Management"
                columns={TABLE_COLUMNS}
                fetchData={getDocuments}
                defaultState={savedState}
                createTableRow={createTableRow}
                showAddButton
                addButtonText="Add Document"
                onAddClick={() => navigate(`${parentRoute}/add-document`, { state: savedState })}
                showSearch
                showStatusFilter
                searchPlaceholder="Search document name..."
                onClickRow={(row, key) => { navigate(`${parentRoute}/${row.id}`, { state: { ...savedState, item: row?.oriData } }) }}
            />
        </DashboardLayout>
    );
}

export default DocumentsTable;